import { type AdminUser } from '../../entities/entityTypes';
import { requestBuilder } from '../../http/RequestBuilder';

interface GetAllAdminUsersVariables {
    activeOnly?: boolean;
}

export const useGetAllAdminUsers = requestBuilder.query<
    AdminUser[],
    GetAllAdminUsersVariables
>({
    endpoint: ({ activeOnly }) =>
        `/api/admin/admin-user/all${activeOnly ? '?activeOnly=true' : ''}`,
    queryKey: ({ activeOnly }) =>
        activeOnly ? 'getAllAdminUsers/active' : 'getAllAdminUsers',
});
